import React, { useEffect, useState } from "react";
import axios from "axios";

import { Row, Col, Card, Typography, Button, Table } from "antd";
import { BarChartOutlined, FileExcelOutlined } from "@ant-design/icons";

import "./css/dashboard.css";

import Barchart from "./chartJs/Barchart";
import Linechart from "./chartJs/Linechart";

import * as xlsx from "xlsx";

const { Title } = Typography;

const cardStyle = {
  height: 420,
  borderRadius: 12,
  boxShadow: "0 6px 16px rgba(0,0,0,0.06)",
  overflow: "hidden"
};

const cardStyle2 = {
  height: 200,
  borderRadius: 12,
  boxShadow: "0 6px 16px rgba(0,0,0,0.06)",
  overflow: "hidden"
};

const cardStyle3 = {
  height: 530,
  borderRadius: 12,
  boxShadow: "0 6px 16px rgba(0,0,0,0.06)",
  overflow: "hidden"
};

const Dashboard7_5 = () => {
  let xURL = "";

  xURL = "https://research.rihes.cmu.ac.th/api/";

  const [dataBar7_5_1, _dataBar7_5_1] = useState();
  const [dataBar7_5_2, _dataBar7_5_2] = useState();
  const [dataBar7_5_3, _dataBar7_5_3] = useState();
  const [dataBar7_5_4, _dataBar7_5_4] = useState();
  const [dataBar7_5_5, _dataBar7_5_5] = useState();
  const [dataBar7_5_6, _dataBar7_5_6] = useState();
  const [dataBar7_5_12, _dataBar7_5_12] = useState();
  const [dataBar7_5_13, _dataBar7_5_13] = useState();
  const [dataBar7_5_15, _dataBar7_5_15] = useState();
  const [dataBar7_5_16, _dataBar7_5_16] = useState();
  const [dataBar7_5_17, _dataBar7_5_17] = useState();
  const [dataBar7_5_18, _dataBar7_5_18] = useState();
  const [dataBar7_5_19, _dataBar7_5_19] = useState();
  const [dataBar7_5_21, _dataBar7_5_21] = useState();

  const [dataLine7_5_9, _dataLine7_5_9] = useState();
  const [dataLine7_5_10, _dataLine7_5_10] = useState();
  const [dataLine7_5_11, _dataLine7_5_11] = useState();

  useEffect(() => {
    Find_barData("bar7_5_1");
    Find_barData("bar7_5_2");
    Find_barData("bar7_5_3");
    Find_barData("bar7_5_4");
    Find_barData("bar7_5_5");
    Find_barData("bar7_5_6");
    Find_barData("bar7_5_12");
    Find_barData("bar7_5_13");
    Find_barData("bar7_5_15");
    Find_barData("bar7_5_16");
    Find_barData("bar7_5_17");
    Find_barData("bar7_5_18");
    Find_barData("bar7_5_19");
    Find_barData("bar7_5_21");

    Find_lineData("line7_5_9");
    Find_lineData("line7_5_10");
    Find_lineData("line7_5_11");
  }, []);

  const Find_barData = order => {
    axios
      .post(xURL + "db_barchart_db7_5", {
        order: order
      })
      .then(result => {
        let Tb1 = [];

        if (result.data) {
          result.data.forEach((i, idx) => {
            let zyear = "";

            zyear = i.name + 543;
            if (order == "bar7_5_1") {
              Tb1.push({
                name: zyear,
                zcount: i.zcount
              });
            } else if (order == "bar7_5_2") {
              Tb1.push({
                name: zyear,
                zcount: i.zcount
              });
            } else if (order == "bar7_5_3") {
              Tb1.push({
                name: zyear,
                zcount: i.zcount
              });
            } else if (order == "bar7_5_4") {
              Tb1.push({
                name: zyear,
                zcount: i.zcount
              });
            } else if (order == "bar7_5_5") {
              Tb1.push({
                name: zyear,
                zcount: i.zcount
              });
            } else if (order == "bar7_5_6") {
              Tb1.push({
                name: zyear,
                zcount: i.zcount
              });
            } else if (order == "bar7_5_12") {
              Tb1.push({
                name: zyear,
                degree_level: i.degree_level,
                total_student: i.total_student
              });
            } else if (order == "bar7_5_13") {
              Tb1.push({
                name: zyear,
                zcount: i.zcount
              });
            } else if (order == "bar7_5_16") {
              Tb1.push({
                name: zyear,
                type_cmu: i.type_cmu,
                zcount: i.zcount
              });
            } else if (order == "bar7_5_17") {
              Tb1.push({
                name: zyear,
                type_cmu: i.type_cmu,
                zcount: i.zcount
              });
            } else if (order == "bar7_5_18") {
              Tb1.push({
                name: zyear,
                type_cmu: i.type_cmu,
                zcount: i.zcount
              });
            } else if (order == "bar7_5_19") {
              Tb1.push({
                name: zyear,
                zcount: i.zcount
              });
            } else if (order == "bar7_5_21") {
              Tb1.push({
                name: zyear,
                type_cmu: i.type_cmu,
                zcount: i.zcount
              });
            }
          });
        }

        if (order == "bar7_5_1") {
          _dataBar7_5_1(Tb1);
        } else if (order == "bar7_5_2") {
          _dataBar7_5_2(Tb1);
        } else if (order == "bar7_5_3") {
          _dataBar7_5_3(Tb1);
        } else if (order == "bar7_5_4") {
          _dataBar7_5_4(Tb1);
        } else if (order == "bar7_5_5") {
          _dataBar7_5_5(Tb1);
        } else if (order == "bar7_5_6") {
          _dataBar7_5_6(Tb1);
        } else if (order == "bar7_5_12") {
          const raw = Tb1; // เก็บก่อน pivot

          const pivot = raw.reduce((acc, r) => {
            const degree = r.degree_level;
            const year = r.name;

            if (!acc[degree]) acc[degree] = { degree };

            acc[degree][year] = r.total_student;
            return acc;
          }, {});

          const chartData = Object.values(pivot);

          const years = [...new Set(raw.map(r => r.name))].sort();

          _dataBar7_5_12({
            data: chartData,
            years
          });

          return; // ⭐ สำคัญ ไม่ให้ set ซ้ำ
        } else if (order == "bar7_5_13") {
          _dataBar7_5_13(Tb1);
        } else if (order == "bar7_5_16") {
          const raw = Tb1; // เก็บก่อน pivot

          const pivot = raw.reduce((acc, r) => {
            const type_cmu = r.type_cmu;
            const year = r.name;

            if (!acc[type_cmu]) acc[type_cmu] = { type_cmu };

            acc[type_cmu][year] = r.zcount;
            return acc;
          }, {});

          const chartData = Object.values(pivot);

          const years = [...new Set(raw.map(r => r.name))].sort();

          _dataBar7_5_16({
            data: chartData,
            years
          });

          return;
        } else if (order == "bar7_5_17") {
          const raw = Tb1; // เก็บก่อน pivot

          const pivot = raw.reduce((acc, r) => {
            const type_cmu = r.type_cmu;
            const year = r.name;

            if (!acc[type_cmu]) acc[type_cmu] = { type_cmu };

            acc[type_cmu][year] = r.zcount;
            return acc;
          }, {});

          const chartData = Object.values(pivot);

          const years = [...new Set(raw.map(r => r.name))].sort();

          _dataBar7_5_17({
            data: chartData,
            years
          });

          return;
        } else if (order == "bar7_5_18") {
          const raw = Tb1; // เก็บก่อน pivot

          const pivot = raw.reduce((acc, r) => {
            const type_cmu = r.type_cmu;
            const year = r.name;

            if (!acc[type_cmu]) acc[type_cmu] = { type_cmu };

            acc[type_cmu][year] = r.zcount;
            return acc;
          }, {});

          const chartData = Object.values(pivot);

          const years = [...new Set(raw.map(r => r.name))].sort();

          _dataBar7_5_18({
            data: chartData,
            years
          });

          return;
        } else if (order == "bar7_5_19") {
          _dataBar7_5_19(Tb1);
        } else if (order == "bar7_5_21") {
          const raw = Tb1; // เก็บก่อน pivot

          const pivot = raw.reduce((acc, r) => {
            const type_cmu = r.type_cmu;
            const year = r.name;

            if (!acc[type_cmu]) acc[type_cmu] = { type_cmu };

            acc[type_cmu][year] = r.zcount;
            return acc;
          }, {});

          const chartData = Object.values(pivot);

          const years = [...new Set(raw.map(r => r.name))].sort();

          _dataBar7_5_21({
            data: chartData,
            years
          });

          return;
        }
      })
      .catch(function(error) {
        // handle error
        console.log("problem here", error);
      });

    let Tb2 = [];
    if (order == "bar7_5_15") {
      Tb2.push({ name: 2567, type_cmu: "Clinical lab", zcount: 0 });
      Tb2.push({ name: 2567, type_cmu: "Specimen processing", zcount: 0 });
      Tb2.push({ name: 2567, type_cmu: "NUTRI & GI lab", zcount: 0 });
      Tb2.push({ name: 2567, type_cmu: "Clinic", zcount: 0 });

      Tb2.push({ name: 2568, type_cmu: "Clinical lab", zcount: 0 });
      Tb2.push({ name: 2568, type_cmu: "Specimen processing", zcount: 14 });
      Tb2.push({ name: 2568, type_cmu: "NUTRI & GI lab", zcount: 184 });
      Tb2.push({ name: 2568, type_cmu: "Clinic", zcount: 368 });

      const raw = Tb2; // เก็บก่อน pivot

      const pivot = raw.reduce((acc, r) => {
        const type_cmu = r.type_cmu;
        const year = r.name;

        if (!acc[type_cmu]) acc[type_cmu] = { type_cmu };

        acc[type_cmu][year] = r.zcount;
        return acc;
      }, {});

      const chartData = Object.values(pivot);

      const years = [...new Set(raw.map(r => r.name))].sort();

      _dataBar7_5_15({
        data: chartData,
        years
      });

      return;
    }
  };

  const Find_lineData = order => {
    axios
      .post(xURL + "db_linechart_db7_5", {
        order: order
      })
      .then(result => {
        let Tb1 = [];

        if (result.data) {
          result.data.forEach((i, idx) => {
            let zyear = "";

            zyear = parseInt(i.name) + 543;

            if (order == "line7_5_9") {
              Tb1.push({
                name: zyear,
                total1: i.total1,
                total2: i.total2
              });
            } else if (order == "line7_5_10") {
              Tb1.push({
                name: zyear,
                total1: i.total1,
                total2: i.total2
              });
            } else if (order == "line7_5_11") {
              Tb1.push({
                name: zyear,
                total1: i.total1,
                total2: i.total2,
                total3: i.total3
              });
            }
          });
        }

        if (order == "line7_5_9") {
          _dataLine7_5_9(Tb1);
        } else if (order == "line7_5_10") {
          _dataLine7_5_10(Tb1);
        } else if (order == "line7_5_11") {
          _dataLine7_5_11(Tb1);
        }
      })
      .catch(function(error) {
        // handle error
        console.log("problem here", error);
      });
  };

  const highlightRows = ["รวม"];

  const columns7_5_12 = [
    {
      title: "ปีการศึกษา",
      dataIndex: "c1",
      key: "c1",
      align: "center",
      render: (text, record) => ({
        children: text,
        props: {
          style: {
            background: highlightRows.includes(record.c1) ? "#fff3cd" : ""
          }
        }
      })
    },
    {
      title: "ปริญญาโท",
      dataIndex: "c2",
      key: "c2",
      align: "center",
      render: (text, record) => ({
        children: text,
        props: {
          style: {
            background: highlightRows.includes(record.c1) ? "#fff3cd" : ""
          }
        }
      })
    },
    {
      title: "ปริญญาเอก",
      dataIndex: "c3",
      key: "c3",
      align: "center",
      render: (text, record) => ({
        children: text,
        props: {
          style: {
            background: highlightRows.includes(record.c1) ? "#fff3cd" : ""
          }
        }
      })
    },
    {
      title: "รวมรับเข้า",
      dataIndex: "c4",
      key: "c4",
      align: "center",
      render: (text, record) => ({
        children: text,
        props: {
          style: {
            background: highlightRows.includes(record.c1) ? "#fff3cd" : ""
          }
        }
      })
    }
  ];

  const data7_5_12 = [
    {
      key: "1",
      c1: "2565",
      c2: "8",
      c3: "12",
      c4: "20"
    },
    {
      key: "2",
      c1: "2566",
      c2: "9",
      c3: "10",
      c4: "19"
    },
    {
      key: "3",
      c1: "2567",
      c2: "9",
      c3: "7",
      c4: "16"
    },
    {
      key: "4",
      c1: "2568",
      c2: "6",
      c3: "15",
      c4: "21"
    },
    {
      key: "5",
      c1: "รวม",
      c2: "32",
      c3: "44",
      c4: "76"
    }
  ];

  const dataEx7_5_12 = [
    {
      c1: "2565",
      c2: "8",
      c3: "12",
      c4: "20"
    },
    {
      c1: "2566",
      c2: "9",
      c3: "10",
      c4: "19"
    },
    {
      c1: "2567",
      c2: "9",
      c3: "7",
      c4: "16"
    },
    {
      c1: "2568",
      c2: "6",
      c3: "15",
      c4: "21"
    },
    {
      c1: "รวม",
      c2: "32",
      c3: "44",
      c4: "76"
    }
  ];

  const columns7_5_13 = [
    {
      title: "ปีการศึกษา",
      dataIndex: "c1",
      key: "c1",
      align: "center",
      render: (text, record) => ({
        children: text,
        props: {
          style: {
            background: highlightRows.includes(record.c1) ? "#fff3cd" : ""
          }
        }
      })
    },
    {
      title: "ปริญญาโท",
      key: "c2",
      align: "center",
      children: [
        {
          title: "ไทย",
          dataIndex: "c2_1",
          key: "c2_1",
          align: "center",
          render: (text, record) => ({
            children: text,
            props: {
              style: {
                background: highlightRows.includes(record.c1) ? "#fff3cd" : ""
              }
            }
          })
        },
        {
          title: "ต่างชาติ",
          dataIndex: "c2_2",
          key: "c2_2",
          align: "center",
          render: (text, record) => ({
            children: text,
            props: {
              style: {
                background: highlightRows.includes(record.c1) ? "#fff3cd" : ""
              }
            }
          })
        }
      ]
    },
    {
      title: "ปริญญาเอก",
      key: "c3",
      align: "center",
      children: [
        {
          title: "ไทย",
          dataIndex: "c3_1",
          key: "c3_1",
          align: "center",
          render: (text, record) => ({
            children: text,
            props: {
              style: {
                background: highlightRows.includes(record.c1) ? "#fff3cd" : ""
              }
            }
          })
        },
        {
          title: "ต่างชาติ",
          dataIndex: "c3_2",
          key: "c3_2",
          align: "center",
          render: (text, record) => ({
            children: text,
            props: {
              style: {
                background: highlightRows.includes(record.c1) ? "#fff3cd" : ""
              }
            }
          })
        }
      ]
    },
    {
      title: "รวมรับเข้า",
      dataIndex: "c4",
      key: "c4",
      align: "center",
      children: [
        {
          title: "ไทย",
          dataIndex: "c4_1",
          key: "c4_1",
          align: "center",
          render: (text, record) => ({
            children: text,
            props: {
              style: {
                background: highlightRows.includes(record.c1) ? "#fff3cd" : ""
              }
            }
          })
        },
        {
          title: "ต่างชาติ",
          dataIndex: "c4_2",
          key: "c4_2",
          align: "center",
          render: (text, record) => ({
            children: text,
            props: {
              style: {
                background: highlightRows.includes(record.c1) ? "#fff3cd" : ""
              }
            }
          })
        }
      ]
    }
  ];

  const data7_5_13 = [
    {
      key: "1",
      c1: "2565",
      c2_1: "5",
      c2_2: (
        <div>
          3 <br />
          (ร้อยละ 60)
        </div>
      ),
      c3_1: "9",
      c3_2: (
        <div>
          3 <br />
          (ร้อยละ 33.3)
        </div>
      ),
      c4_1: "14",
      c4_2: (
        <div>
          6 <br />
          (ร้อยละ 30)
        </div>
      )
    },
    {
      key: "2",
      c1: "2566",
      c2_1: "1",
      c2_2: (
        <div>
          8 <br />
          (ร้อยละ 800)
        </div>
      ),
      c3_1: "2",
      c3_2: (
        <div>
          8 <br />
          (ร้อยละ 400)
        </div>
      ),
      c4_1: "3",
      c4_2: (
        <div>
          16 <br />
          (ร้อยละ 533.33)
        </div>
      )
    },
    {
      key: "3",
      c1: "2567",
      c2_1: "4",
      c2_2: (
        <div>
          5 <br />
          (ร้อยละ 125)
        </div>
      ),
      c3_1: "2",
      c3_2: (
        <div>
          5 <br />
          (ร้อยละ 250)
        </div>
      ),
      c4_1: "6",
      c4_2: (
        <div>
          10 <br />
          (ร้อยละ 166.66)
        </div>
      )
    },
    {
      key: "4",
      c1: "2568",
      c2_1: "3",
      c2_2: (
        <div>
          3 <br />
          (ร้อยละ 100)
        </div>
      ),
      c3_1: "4",
      c3_2: (
        <div>
          11 <br />
          (ร้อยละ 275)
        </div>
      ),
      c4_1: "7",
      c4_2: (
        <div>
          14 <br />
          (ร้อยละ 200)
        </div>
      )
    },
    {
      key: "5",
      c1: "รวม",
      c2_1: "13",
      c2_2: "19",
      c3_1: "17",
      c3_2: "27",
      c4_1: "32",
      c4_2: (
        <div>
          44 <br />
          (ร้อยละ 137.5)
        </div>
      )
    }
  ];

  const dataEx7_5_13 = [
    {
      c1: "2565",
      c2_1: "5",
      c2_2: "3 (ร้อยละ 60)",
      c3_1: "9",
      c3_2: "3 (ร้อยละ 33.3)",
      c4_1: "14",
      c4_2: "6 (ร้อยละ 30)"
    },
    {
      c1: "2566",
      c2_1: "1",
      c2_2: "8 (ร้อยละ 800)",
      c3_1: "2",
      c3_2: "8 (ร้อยละ 400)",
      c4_1: "3",
      c4_2: "16 (ร้อยละ 533.33)"
    },
    {
      c1: "2567",
      c2_1: "4",
      c2_2: "5 (ร้อยละ 125)",
      c3_1: "2",
      c3_2: "5 (ร้อยละ 250)",
      c4_1: "6",
      c4_2: "10 (ร้อยละ 166.66)"
    },
    {
      c1: "2568",
      c2_1: "3",
      c2_2: "3 (ร้อยละ 100)",
      c3_1: "4",
      c3_2: "11 (ร้อยละ 275)",
      c4_1: "7",
      c4_2: "14 (ร้อยละ 200)"
    },
    {
      c1: "รวม",
      c2_1: "13",
      c2_2: "19",
      c3_1: "17",
      c3_2: "27",
      c4_1: "32",
      c4_2: "44 (ร้อยละ 137.5)"
    }
  ];

  const columns7_5_22 = [
    {
      title: "SO",
      dataIndex: "c1",
      key: "c1",
      align: "center"
    },
    {
      title: "Key Resulth",
      dataIndex: "c2",
      key: "c2",
      align: "center",
      render: text =>
        <div style={{ textAlign: "left" }}>
          {text}
        </div>
    },
    {
      title: "เป้าหมาย68",
      dataIndex: "c3",
      key: "c3",
      align: "center"
    },
    {
      title: "ผลการดำเนินงาน68",
      dataIndex: "c4",
      key: "c4",
      align: "center"
    }
  ];

  const data7_5_22 = [
    {
      key: "1",
      c1: "R",
      c2: "ระบบติดตามและการประเมินผลการขอทุน (ระบบ)",
      c3: "1",
      c4: "1"
    },
    {
      key: "2",
      c1: "I",
      c2: "มีการพัฒนาหลักสูตรใหม่",
      c3: "1 หลักสูตร",
      c4: "มหาวิทยาลัยฯ มีนโยบายให้เปิดเป็นแขนงวิชา"
    },
    {
      key: "3",
      c1: "H",
      c2: "เครือข่ายของโครงการคืนลมหายใจที่ไร้ฝุ่น",
      c3: "เพิ่มเครือข่ายความร่วมมือ",
      c4: "มีเครื่อข่ายเพิ่มขึ้น 1 เครือข่าย"
    },
    {
      key: "4",
      c1: "E",
      c2:
        "แผนงานการขับเคลื่อนองค์กรสู่ความเป็นเลิศ ตามเกณฑ์รางวัลคุณภาพแห่งชาติ (TOA)",
      c3: "EdPEx 300",
      c4: "ยังไม่มีการประเมิณ"
    },
    {
      key: "5",
      c1: "S",
      c2: "Recruitment success rate เพิ่มขึ้น (%)",
      c3: "",
      c4: ""
    },
    {
      key: "6",
      c1: "",
      c2: "Retention rate เพิ่มขึ้น (%)",
      c3: "",
      c4: ""
    },
    {
      key: "7",
      c1: "",
      c2: "Business Model ใหม่ (Model)",
      c3: "",
      c4: ""
    }
  ];

  const dataEx7_5_22 = [
    {
      c1: "R",
      c2: "ระบบติดตามและการประเมินผลการขอทุน (ระบบ)",
      c3: "1",
      c4: "1"
    },
    {
      c1: "I",
      c2: "มีการพัฒนาหลักสูตรใหม่",
      c3: "1 หลักสูตร",
      c4: "มหาวิทยาลัยฯ มีนโยบายให้เปิดเป็นแขนงวิชา"
    },
    {
      c1: "H",
      c2: "เครือข่ายของโครงการคืนลมหายใจที่ไร้ฝุ่น",
      c3: "เพิ่มเครือข่ายความร่วมมือ",
      c4: "มีเครื่อข่ายเพิ่มขึ้น 1 เครือข่าย"
    },
    {
      c1: "E",
      c2:
        "แผนงานการขับเคลื่อนองค์กรสู่ความเป็นเลิศ ตามเกณฑ์รางวัลคุณภาพแห่งชาติ (TOA)",
      c3: "EdPEx 300",
      c4: "ยังไม่มีการประเมิณ"
    },
    {
      c1: "S",
      c2: "Recruitment success rate เพิ่มขึ้น (%)",
      c3: "",
      c4: ""
    },
    {
      c1: "",
      c2: "Retention rate เพิ่มขึ้น (%)",
      c3: "",
      c4: ""
    },
    {
      c1: "",
      c2: "Business Model ใหม่ (Model)",
      c3: "",
      c4: ""
    }
  ];

  const bExcelClick = xorder => {
    // console.log("Excel button clicked for order:", xorder);
    let xdata = [],
      xtabtitle = "report",
      header = [],
      header2 = [];

    if (xorder === "7_5_12") {
      xtabtitle = "7.5-12 จำนวนนักศึกษาแรกเข้าในแต่ละหลักสูตร (คน)";
      header = ["ปีการศึกษา", "ปริญญาโท", "ปริญญาเอก", "รวมรับเข้า"];
    } else if (xorder === "7_5_13") {
      xtabtitle = "7.5-13 ร้อยละของนักศึกษาแรกเข้าที่เป็นคนต่างชาติ";
      header = [
        "ปีการศึกษา",
        "ปริญญาโท",
        "",
        "ปริญญาเอก",
        "",
        "รวมรับเข้า",
        ""
      ];
      header2 = ["", "ไทย", "ต่างชาติ", "ไทย", "ต่างชาติ", "ไทย", "ต่างชาติ"];
    } else if (xorder === "7_5_22") {
      xtabtitle = "7.5-22 ความสำเร็จของแผนปฏิบัติการ";
      header = ["SO", "Key Resulth", "เป้าหมาย 68", "ผลการดำเนินงาน 68"];
    }

    xdata.push([xtabtitle]);

    xdata.push([""]);
    xdata.push(header);
    if (header2.length > 0) {
      xdata.push(header2);
    }

    if (xorder === "7_5_12") {
      for (var row in dataEx7_5_12) {
        const xx = [];

        for (var col in dataEx7_5_12[row]) {
          xx.push(dataEx7_5_12[row][col]);
        }

        xdata.push(xx);
      }
    } else if (xorder === "7_5_13") {
      for (var row in dataEx7_5_13) {
        const xx = [];

        for (var col in dataEx7_5_13[row]) {
          xx.push(dataEx7_5_13[row][col]);
        }

        xdata.push(xx);
      }
    } else if (xorder === "7_5_22") {
      for (var row in dataEx7_5_22) {
        const xx = [];

        for (var col in dataEx7_5_22[row]) {
          xx.push(dataEx7_5_22[row][col]);
        }

        xdata.push(xx);
      }
    }

    var wb = xlsx.utils.book_new(),
      ws = xlsx.utils.json_to_sheet(xdata, { skipHeader: true });

    xlsx.utils.book_append_sheet(wb, ws, "Sheet1");
    xlsx.writeFile(wb, xtabtitle + ".xlsx");
  };

  return (
    <React.Fragment>
      {/* Page Title */}
      <div style={{ marginBottom: 24 }}>
        <Title level={2} className="gradient-text">
          ผลลัพธ์ด้านการเงิน ตลาด และกลยุทธ์
        </Title>
      </div>

      {/* Row 1 */}
      <Row gutter={[16, 16]}>
        <Col xs={24} lg={12}>
          <Card
            bordered={false}
            style={{
              ...cardStyle,
              borderTop: "4px solid rgb(127, 141, 224)"
            }}
            title="7.5-1 รายได้รวมจากผลิตภัณฑ์และบริการ (ล้านบาท)"
          >
            <Barchart dataBar={dataBar7_5_1} order={"bar7_5_1"} />

            <div
              style={{
                marginTop: 12,
                fontSize: 12,
                color: "#888",
                fontStyle: "italic"
              }}
            >
              หมายเหตุ: ข้อมูลอ้างอิงตามปีงบประมาณ
            </div>
          </Card>
        </Col>

        <Col xs={24} lg={12}>
          <Card
            bordered={false}
            style={{
              ...cardStyle,
              borderTop: "4px solid rgb(127, 141, 224)"
            }}
            title="7.5-2 รายได้จากการวิจัย (ล้านบาท)"
          >
            <Barchart dataBar={dataBar7_5_2} order={"bar7_5_2"} />

            <div
              style={{
                marginTop: 12,
                fontSize: 12,
                color: "#888",
                fontStyle: "italic"
              }}
            >
              หมายเหตุ: ข้อมูลอ้างอิงตามปีงบประมาณ
            </div>
          </Card>
        </Col>
      </Row>

      {/* Row 2 */}
      <Row gutter={[16, 16]}>
        <Col xs={24} lg={12}>
          <Card
            bordered={false}
            style={{
              ...cardStyle,
              borderTop: "4px solid rgb(127, 141, 224)"
            }}
            title="7.5-3 จำนวนเงินทุนวิจัยจากแหล่งทุนต่างประเทศ (ล้านบาท)"
          >
            <Barchart dataBar={dataBar7_5_3} order={"bar7_5_3"} />

            <div
              style={{
                marginTop: 12,
                fontSize: 12,
                color: "#888",
                fontStyle: "italic"
              }}
            >
              หมายเหตุ: ข้อมูลอ้างอิงตามปีงบประมาณ
            </div>
          </Card>
        </Col>

        <Col xs={24} lg={12}>
          <Card
            bordered={false}
            style={{
              ...cardStyle,
              borderTop: "4px solid rgb(127, 141, 224)"
            }}
            title="7.5-4 จำนวนเงินทุนวิจัยจากแหล่งทุนในประเทศ (ล้านบาท)"
          >
            <Barchart dataBar={dataBar7_5_4} order={"bar7_5_4"} />

            <div
              style={{
                marginTop: 12,
                fontSize: 12,
                color: "#888",
                fontStyle: "italic"
              }}
            >
              หมายเหตุ: ข้อมูลอ้างอิงตามปีงบประมาณ
            </div>
          </Card>
        </Col>
      </Row>

      {/* Row 3 */}
      <Row gutter={[16, 16]}>
        <Col xs={24} lg={12}>
          <Card
            bordered={false}
            style={{
              ...cardStyle,
              borderTop: "4px solid rgb(127, 141, 224)"
            }}
            title="7.5-5 รายได้จากการศึกษา (ล้านบาท)"
          >
            <Barchart dataBar={dataBar7_5_5} order={"bar7_5_5"} />

            <div
              style={{
                marginTop: 12,
                fontSize: 12,
                color: "#888",
                fontStyle: "italic"
              }}
            >
              หมายเหตุ: ข้อมูลอ้างอิงตามปีงบประมาณ
            </div>
          </Card>
        </Col>

        <Col xs={24} lg={12}>
          <Card
            bordered={false}
            style={{
              ...cardStyle,
              borderTop: "4px solid rgb(127, 141, 224)"
            }}
            title="7.5-6 รายได้จากการบริการวิชาการ (ล้านบาท)"
          >
            <Barchart dataBar={dataBar7_5_6} order={"bar7_5_6"} />

            <div
              style={{
                marginTop: 12,
                fontSize: 12,
                color: "#888",
                fontStyle: "italic"
              }}
            >
              หมายเหตุ: ข้อมูลอ้างอิงตามปีงบประมาณ
            </div>
          </Card>
        </Col>
      </Row>

      {/* Row 5 */}
      <Row gutter={[16, 16]} style={{ marginTop: 16 }}>
        <Col xs={24} lg={12}>
          <Card
            bordered={false}
            style={{
              ...cardStyle2,
              borderTop: "4px solid rgb(127, 141, 224)"
            }}
            title="7.5-7 ผลลัพธ์ทางการเงินของสถาบันฯ"
          >
            <div
              style={{
                height: 80,
                display: "flex",
                justifyContent: "center",
                alignItems: "center"
              }}
            >
              <Button
                type="primary"
                icon={<BarChartOutlined />}
                size="large"
                style={{
                  borderRadius: 10,
                  height: 50,
                  padding: "0 28px",
                  fontWeight: 500
                }}
                onClick={() =>
                  window.open(
                    xURL +
                      "dashboard4/7_5/file_7_5_7_ผลลัพธ์ทางการเงินของสถาบันฯ_ปี_63_68.xlsx",
                    "_blank"
                  )}
              >
                ผลลัพธ์ทางการเงินของสถาบันฯ
              </Button>
            </div>
          </Card>
        </Col>

        <Col xs={24} lg={12}>
          <Card
            bordered={false}
            style={{
              ...cardStyle2,
              borderTop: "4px solid rgb(127, 141, 224)"
            }}
            title="7.5-8 จำนวนเงินทุนวิจัยจาก NIH ที่ได้รับต่อเนื่องมากกว่า 20 ปี"
          >
            <div
              style={{
                height: 80,
                display: "flex",
                justifyContent: "center",
                alignItems: "center"
              }}
            >
              <Button
                type="primary"
                icon={<BarChartOutlined />}
                size="large"
                style={{
                  borderRadius: 10,
                  height: 50,
                  padding: "0 28px",
                  fontWeight: 500
                }}
                onClick={() =>
                  window.open(
                    xURL + "dashboard4/7_5/pic_7_5_8_NIH.jpg",
                    "_blank"
                  )}
              >
                จำนวนเงินทุนวิจัยจาก NIH ที่ได้รับต่อเนื่องมากกว่า 20 ปี
              </Button>
            </div>
          </Card>
        </Col>
      </Row>

      {/* Row 6 */}
      <Row gutter={[16, 16]} style={{ marginTop: 16 }}>
        <Col xs={24} lg={12}>
          <Card
            bordered={false}
            style={{
              ...cardStyle,
              borderTop: "4px solid rgb(127, 141, 224)"
            }}
            title="7.5-9 จำนวนโครงการวิจัยแยกตามแหล่งทุน (โครงการ)"
          >
            <Linechart dataLine={dataLine7_5_9} order={"line7_5_9"} />

            <div
              style={{
                marginTop: 12,
                fontSize: 12,
                color: "#888",
                fontStyle: "italic"
              }}
            >
              หมายเหตุ: ข้อมูลอ้างอิงตามปีงบประมาณ (1 ต.ค. - 30 ก.ย.)
            </div>
          </Card>
        </Col>

        <Col xs={24} lg={12}>
          <Card
            bordered={false}
            style={{
              ...cardStyle,
              borderTop: "4px solid rgb(127, 141, 224)"
            }}
            title="7.5-10 จำนวนโครงการวิจัยแยกตามประเภททุน (โครงการ)"
          >
            <Linechart dataLine={dataLine7_5_10} order={"line7_5_10"} />

            <div
              style={{
                marginTop: 12,
                fontSize: 12,
                color: "#888",
                fontStyle: "italic"
              }}
            >
              หมายเหตุ: ข้อมูลอ้างอิงตามปีงบประมาณ (1 ต.ค. - 30 ก.ย.)
            </div>
          </Card>
        </Col>
      </Row>

      {/* Row 7 */}
      <Row gutter={[16, 16]} style={{ marginTop: 16 }}>
        <Col xs={24} lg={12}>
          <Card
            bordered={false}
            style={{
              ...cardStyle,
              borderTop: "4px solid rgb(127, 141, 224)"
            }}
            title="7.5-11 จำนวนโครงการวิจัยแยกตามทิศทาง (โครงการ)"
          >
            <Linechart dataLine={dataLine7_5_11} order={"line7_5_11"} />

            <div
              style={{
                marginTop: 12,
                fontSize: 12,
                color: "#888",
                fontStyle: "italic"
              }}
            >
              หมายเหตุ: ข้อมูลอ้างอิงตามปีงบประมาณ (1 ต.ค. - 30 ก.ย.)
            </div>
          </Card>
        </Col>

        <Col xs={24} lg={12}>
          <Card
            bordered={false}
            style={{
              ...cardStyle,
              borderTop: "4px solid rgb(127, 141, 224)"
            }}
            title="7.5-12 จำนวนนักศึกษาแรกเข้าในแต่ละหลักสูตร (คน)"
          >
            {/* <Barchart dataBar={dataBar7_5_12} order={"bar7_5_12"} />

            <div
              style={{
                marginTop: 12,
                fontSize: 12,
                color: "#888",
                fontStyle: "italic"
              }}
            >
              หมายเหตุ: ข้อมูลอ้างอิงตามปีปฏิทิน
            </div> */}

            <Row style={{ float: "right", marginBottom: 8 }}>
              <Button
                ghost
                type="success"
                onClick={() => bExcelClick("7_5_12")}
              >
                <FileExcelOutlined /> Excel
              </Button>
            </Row>

            <Table
              columns={columns7_5_12}
              dataSource={data7_5_12}
              pagination={false}
              size="small"
              bordered
            />
          </Card>
        </Col>
      </Row>

      {/* Row 8 */}
      <Row gutter={[16, 16]} style={{ marginTop: 16 }}>
        <Col xs={24} lg={12}>
          <Card
            bordered={false}
            style={{
              ...cardStyle3,
              borderTop: "4px solid rgb(127, 141, 224)"
            }}
            title="7.5-13 ร้อยละของนักศึกษาแรกเข้าที่เป็นคนต่างชาติ"
          >
            {/* <Barchart dataBar={dataBar7_5_13} order={"bar7_5_13"} />

            <div
              style={{
                marginTop: 12,
                fontSize: 12,
                color: "#888",
                fontStyle: "italic"
              }}
            >
              หมายเหตุ: ข้อมูลอ้างอิงตามปีปฏิทิน
            </div> */}

            <Row style={{ float: "right", marginBottom: 8 }}>
              <Button
                ghost
                type="success"
                onClick={() => bExcelClick("7_5_13")}
              >
                <FileExcelOutlined /> Excel
              </Button>
            </Row>

            <Table
              columns={columns7_5_13}
              dataSource={data7_5_13}
              pagination={false}
              size="small"
              bordered
            />
          </Card>
        </Col>

        <Col xs={24} lg={12}>
          <Card
            bordered={false}
            style={{
              ...cardStyle3,
              borderTop: "4px solid rgb(127, 141, 224)"
            }}
            title="7.5-14 จำนวนผู้ใช้บริการวิชาการของสถาบันฯ"
          >
            <div
              style={{
                height: 280,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexDirection: "column",
                color: "#9aa0a6"
              }}
            >
              <div style={{ fontSize: 28 }}>📊</div>
              <div style={{ fontSize: 16, marginTop: 8 }}>ยังไม่มีข้อมูล</div>
              <div style={{ fontSize: 12, marginTop: 4 }}>
                ไม่มีข้อมูลสำหรับแสดงในขณะนี้
              </div>
              <div style={{ fontSize: 12, marginTop: 4 }}>
                (รอ link ไปไฟล์พี่ทราย)
              </div>
            </div>
          </Card>
        </Col>
      </Row>

      {/* Row 9 */}
      <Row gutter={[16, 16]} style={{ marginTop: 16 }}>
        <Col xs={24} lg={12}>
          <Card
            bordered={false}
            style={{
              ...cardStyle,
              borderTop: "4px solid rgb(127, 141, 224)"
            }}
            title="7.5-15 จำนวนผู้ใช้บริการในธุรกิจต่างๆ ของสถาบันฯ (ครั้ง)"
          >
            <Barchart dataBar={dataBar7_5_15} order={"bar7_5_15"} />

            <div
              style={{
                marginTop: 12,
                fontSize: 12,
                color: "#888",
                fontStyle: "italic"
              }}
            >
              หมายเหตุ: ข้อมูลอ้างอิงตามปีงบประมาณ
            </div>
          </Card>
        </Col>

        <Col xs={24} lg={12}>
          <Card
            bordered={false}
            style={{
              ...cardStyle,
              borderTop: "4px solid rgb(127, 141, 224)"
            }}
            title="7.5-16 จำนวนเงินทุนวิจัยแยกตามทิศทาง (ล้านบาท)"
          >
            <Barchart dataBar={dataBar7_5_16} order={"bar7_5_16"} />

            <div
              style={{
                marginTop: 12,
                fontSize: 12,
                color: "#888",
                fontStyle: "italic"
              }}
            >
              หมายเหตุ: ข้อมูลอ้างอิงตามปีงบประมาณ
            </div>
          </Card>
        </Col>
      </Row>

      {/* Row 10 */}
      <Row gutter={[16, 16]} style={{ marginTop: 16 }}>
        <Col xs={24} lg={12}>
          <Card
            bordered={false}
            style={{
              ...cardStyle,
              borderTop: "4px solid rgb(127, 141, 224)"
            }}
            title="7.5-17 จำนวนผลงานตีพิมพ์ของ BEEN research (เรื่อง)"
          >
            <Barchart dataBar={dataBar7_5_17} order={"bar7_5_17"} />

            <div
              style={{
                marginTop: 12,
                fontSize: 12,
                color: "#888",
                fontStyle: "italic"
              }}
            >
              หมายเหตุ: ข้อมูลอ้างอิงตามปีปฏิทิน
            </div>
          </Card>
        </Col>

        <Col xs={24} lg={12}>
          <Card
            bordered={false}
            style={{
              ...cardStyle,
              borderTop: "4px solid rgb(127, 141, 224)"
            }}
            title="7.5-18 จำนวนผลงานตีพิมพ์ของ BEEN research ใน Q1"
          >
            <Barchart dataBar={dataBar7_5_18} order={"bar7_5_18"} />

            <div
              style={{
                marginTop: 12,
                fontSize: 12,
                color: "#888",
                fontStyle: "italic"
              }}
            >
              หมายเหตุ: ข้อมูลอ้างอิงตามปีปฏิทิน
            </div>
          </Card>
        </Col>
      </Row>

      {/* Row 11 */}
      <Row gutter={[16, 16]} style={{ marginTop: 16 }}>
        <Col xs={24} lg={12}>
          <Card
            bordered={false}
            style={{
              ...cardStyle,
              borderTop: "4px solid rgb(127, 141, 224)"
            }}
            title="7.5-19 จำนวนผลงานอนุสิทธิบัตร/สิทธิบัตร"
          >
            <Barchart dataBar={dataBar7_5_19} order={"bar7_5_19"} />

            <div
              style={{
                marginTop: 12,
                fontSize: 12,
                color: "#888",
                fontStyle: "italic"
              }}
            >
              หมายเหตุ: ข้อมูลอ้างอิงตามปีปฏิทิน
            </div>
          </Card>
        </Col>

        <Col xs={24} lg={12}>
          <Card
            bordered={false}
            style={{
              ...cardStyle,
              borderTop: "4px solid rgb(127, 141, 224)"
            }}
            title="7.5-20 จำนวนผลงานตีพิมพ์ที่มีผู้ร่วมแต่งจากหน่วยงานต่างประเทศ (เรื่อง)"
          >
            <div
              style={{
                height: 280,
                display: "flex",
                justifyContent: "center",
                alignItems: "center"
              }}
            >
              <Button
                type="primary"
                icon={<BarChartOutlined />}
                size="large"
                style={{
                  borderRadius: 10,
                  height: 50,
                  padding: "0 28px",
                  fontWeight: 500
                }}
                onClick={() =>
                  window.open(
                    xURL +
                      "dashboard4/7_5/file_7_5_20_จำนวนผลงานตีพิมพ์ที่มีผู้ร่วมแต่งจากหน่วยงานต่างประเทศ.xlsx",
                    "_blank"
                  )}
              >
                จำนวนผลงานตีพิมพ์ที่มีผู้ร่วมแต่งจากหน่วยงานต่างประเทศ
              </Button>
            </div>
          </Card>
        </Col>
      </Row>

      {/* Row 11 */}
      <Row gutter={[16, 16]} style={{ marginTop: 16 }}>
        <Col xs={24} lg={12}>
          <Card
            bordered={false}
            style={{
              ...cardStyle3,
              borderTop: "4px solid rgb(127, 141, 224)"
            }}
            title="7.5-21 จำนวนเงินรายได้จากธุรกิจใหม่ (ล้านบาท)"
          >
            <div style={{ height: "20px" }} />
            <Barchart dataBar={dataBar7_5_21} order={"bar7_5_21"} />

            <div
              style={{
                marginTop: 12,
                fontSize: 12,
                color: "#888",
                fontStyle: "italic"
              }}
            >
              หมายเหตุ: ข้อมูลอ้างอิงตามปีงบประมาณ
            </div>
          </Card>
        </Col>

        <Col xs={24} lg={12}>
          <Card
            bordered={false}
            style={{
              ...cardStyle3,
              borderTop: "4px solid rgb(127, 141, 224)"
            }}
            title="7.5-22 ความสำเร็จของแผนปฏิบัติการ"
          >
            <Row style={{ float: "right", marginBottom: 8 }}>
              <Button
                ghost
                type="success"
                onClick={() => bExcelClick("7_5_22")}
              >
                <FileExcelOutlined /> Excel
              </Button>
            </Row>

            <Table
              columns={columns7_5_22}
              dataSource={data7_5_22}
              pagination={false}
              size="small"
              bordered
            />
          </Card>
        </Col>
      </Row>

      {/* Row 12 */}
      <Row gutter={[16, 16]} style={{ marginTop: 16 }}>
        <Col xs={24} lg={12}>
          <Card
            bordered={false}
            style={{
              ...cardStyle2,
              borderTop: "4px solid rgb(127, 141, 224)"
            }}
            title="7.5-23 ความสำเร็จของแผนกลยุทธ์"
          >
            <div
              style={{
                height: 60,
                display: "flex",
                justifyContent: "center",
                alignItems: "center"
              }}
            >
              <Button
                type="primary"
                icon={<BarChartOutlined />}
                size="large"
                style={{
                  borderRadius: 10,
                  height: 50,
                  padding: "0 28px",
                  fontWeight: 500
                }}
                onClick={() =>
                  window.open(
                    xURL +
                      "dashboard4/7_5/pic_7_5_23_ความสำเร็จของแผนกลยุทธ์.png",
                    "_blank"
                  )}
              >
                ความสำเร็จของแผนกลยุทธ์
              </Button>
            </div>

            <a
              href={
                xURL + "dashboard4/7_5/file_7_5_23_ความสำเร็จของแผนกลยุทธ์.docx"
              }
              download="file_7_5_23_ความสำเร็จของแผนกลยุทธ์.docx"
            >
              <Button
                size="small"
                style={{
                  borderRadius: 10,
                  height: 30,
                  padding: "0 28px"
                }}
              >
                ดาวน์โหลดไฟล์
              </Button>
            </a>
          </Card>
        </Col>
      </Row>
    </React.Fragment>
  );
};

export default Dashboard7_5;
